import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import db from '@/utils/localstorage'
import { getAppId } from '@/utils/applicationPublish'
import store from '@/store/index'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import tempUserRouters from './userRouters.json'

Vue.use(Router)

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/error',
    component: Layout,
    redirect: 'noRedirect',
    name: 'ErrorPages',
    meta: {
      title: 'errorPages',
      icon: '404'
    },
    children: [
      {
        path: '404',
        component: () => import('@/views/error-page/404'),
        name: 'Page404',
        meta: { title: 'page404', noCache: true }
      },
      {
        path: '401',
        component: () => import('@/views/error-page/401'),
        name: 'Page401',
        meta: { title: 'page401', noCache: true }
      }
    ]
  },
  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/profile/index'),
        name: 'Profile',
        meta: { title: 'Profile', icon: 'user', noCache: true }
      }
    ]
  }
]

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const whiteList = []
let asyncRouter

// let asyncRouter

const router = createRouter()

// 导航守卫，渲染动态路由
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (!store.state.applicationPublish.appId) {
    store.commit('applicationPublish/setAppId', getAppId())
  }
  if (whiteList.indexOf(to.path) !== -1) {
    asyncRouter = null
    next()
  } else {
    const token = db.get('ACCESS_TOKEN')
    const user = db.get('USER')
    const userRouter = get('USER_ROUTER')
    // store.dispatch('account/keycloakLogout') // 开发调试
    let noRoles = true
    user &&
      user.roles &&
      user.roles.forEach(item => {
        if (item === 'developer_tenant' || item === 'developer_admin' || item === 'developer_auditor') {
          noRoles = false
        }
      })
    if (token.length && user && !noRoles) {
      if (!asyncRouter) {
        if (!userRouter) {
          // 暂时模拟从后台获取路由，实则在前台
          let permissions = tempUserRouters.permissions
          if (user.roles.includes('developer_admin')) {
            // tempUserRouters.permissions_admin管理员按钮权限
            permissions = permissions.concat(tempUserRouters.permissions_admin)
          }
          store.commit('account/setPermissions', permissions)
          asyncRouter = tempUserRouters.routes
          // 筛选权限路由
          const tempArr = []
          asyncRouter.forEach(route => {
            if (!route.permissions) {
              tempArr.push(route)
            } else {
              route.permissions.forEach(routePermission => {
                user.roles.forEach(role => {
                  if (role === routePermission) {
                    // 审核员只能查看 应用信息 依赖管理 部分的菜单
                    if (user.roles.includes('developer_auditor') &&
                      route.name === '应用信息' &&
                      route.children &&
                      Array.isArray(route.children)) {
                      route.children.forEach(child => {
                        if (child.isHiddenFromAuditor && child.isHiddenFromAuditor === true) {
                          child.hidden = child.isHiddenFromAuditor
                        }
                      })
                    }
                    tempArr.push(route) // 只要有就添加，所以需要去重。又有管理员又有开发者。
                  }
                })
              })
            }
          })
          asyncRouter = [...new Set(tempArr)]
          store.commit('account/setRoutes', asyncRouter)
          save('USER_ROUTER', asyncRouter)
          go(to, next)
        } else {
          asyncRouter = userRouter
          go(to, next)
        }
      } else {
        next()
      }
    } else {
      console.log('进入else', to)
      to.fullPath === '/error/401' ? next() : next('/error/401')
      // 没有角色的时候，跳转到401界面
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})

function go(to, next) {
  asyncRouter = filterAsyncRouter(asyncRouter)
  router.addRoutes(asyncRouter)
  next({ ...to, replace: true })
}

function save(name, data) {
  localStorage.setItem(name, JSON.stringify(data))
}

function get(name) {
  return JSON.parse(localStorage.getItem(name))
}

function filterAsyncRouter(routes) {
  return routes.filter(route => {
    const component = route.component
    if (component) {
      if (route.component === 'Layout') {
        route.component = Layout
      } else {
        route.component = view(component)
      }
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children)
      }
      return true
    }
  })
}
// 重置路由
export function resetRouter(userRoutes2) {
  let userRoutes = userRoutes2
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // 新路由实例matcer，赋值给旧路由实例的matcher，（相当于replaceRouter）
  router.options.routes = []
  userRoutes = filterAsyncRouter(userRoutes)
  router.addRoutes(userRoutes)
}

function view(path) {
  return resolve => require([`@/views/${path}.vue`], resolve)
}

export default router
